'use strict';

// Code for connecting between a noflo.Graph instance and a noflo-runtime
exports.sendGraph = function (graph, runtime, callback, main) {
  var edge, graphId, i, iip, j, k, len, len1, len2, node, priv, pub, ref, ref1, ref2, ref3, ref4, ref5, ref6;
  if ((ref = graph.properties.environment) != null ? ref.type : void 0) {
    if ((ref1 = graph.properties.environment.type) !== 'all' && ref1 !== runtime.definition.type) {
      return callback(new Error('Graph type ' + graph.properties.environment.type + ' doesn\'t match runtime type ' + runtime.definition.type));
    }
  }
  if (!runtime.canDo('protocol:graph')) {
    return callback(new Error('Runtime doesn\'t support graph protocol'));
  }
  graphId = graph.name || graph.properties.id;
  runtime.sendGraph('clear', {
    id: graphId,
    name: graph.name,
    main: main,
    library: graph.properties.project,
    icon: graph.properties.icon || '',
    description: graph.properties.description || ''
  });
  ref2 = graph.nodes;
  for (i = 0, len = ref2.length; i < len; i++) {
    node = ref2[i];
    runtime.sendGraph('addnode', {
      id: node.id,
      component: node.component,
      metadata: node.metadata,
      graph: graphId
    });
  }
  ref3 = graph.edges;
  for (j = 0, len1 = ref3.length; j < len1; j++) {
    edge = ref3[j];
    runtime.sendGraph('addedge', {
      src: {
        node: edge.from.node,
        port: edge.from.port
      },
      tgt: {
        node: edge.to.node,
        port: edge.to.port
      },
      metadata: edge.metadata,
      graph: graphId
    });
  }
  ref4 = graph.initializers;
  for (k = 0, len2 = ref4.length; k < len2; k++) {
    iip = ref4[k];
    runtime.sendGraph('addinitial', {
      src: {
        data: iip.from.data
      },
      tgt: {
        node: iip.to.node,
        port: iip.to.port
      },
      metadata: iip.metadata,
      graph: graphId
    });
  }
  if (graph.inports) {
    ref5 = graph.inports;
    for (pub in ref5) {
      priv = ref5[pub];
      runtime.sendGraph('addinport', {
        public: pub,
        node: priv.process,
        port: priv.port,
        graph: graphId
      });
    }
  }
  if (graph.outports) {
    ref6 = graph.outports;
    for (pub in ref6) {
      priv = ref6[pub];
      runtime.sendGraph('addoutport', {
        public: pub,
        node: priv.process,
        port: priv.port,
        graph: graphId
      });
    }
  }
  return callback();
};